import React from "react";
import { toast } from "sonner";
import { Share2 } from "lucide-react";

export const ShareButton = ({ kind, slug, title, compact = false }) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/${kind}/${slug}`;

  const onShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: `${title} | Gremlin Coffee`, url });
      } else {
        await navigator.clipboard.writeText(url);
        toast.success("Share link copied.");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't share. Try copying the link.");
    }
  };

  if (compact) {
    return (
      <button
        onClick={onShare}
        data-testid={`share-${kind}-${slug}`}
        aria-label={`Share ${title}`}
        className="text-cream/75 hover:text-ember transition-colors p-1.5"
      >
        <Share2 size={15} />
      </button>
    );
  }

  return (
    <button
      onClick={onShare}
      data-testid={`share-${kind}-${slug}`}
      className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest border border-white/15 text-cream/70 px-5 py-3 rounded-full hover:border-ember hover:text-ember transition-colors"
    >
      <Share2 size={14} /> Share
    </button>
  );
};
